import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatting',
  standalone: true
})
export class FormattingPipe implements PipeTransform {

  transform(value: any, format: string = 'money', decimalCount: number = 2, decimal: string = ',', thousands: string = '.'): any {
    switch (format) {
      case 'date':
        return this.formatDate(value);
      case 'money':
        return this.formatMoney(value, decimalCount, decimal, thousands);
      case 'rate':
        return this.formatRate(value);
      default:
        return value;
    }
  }

  formatDate(dateString: string): string {
    const [year, month, day] = dateString.split('-');
    const months = [
       'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
       'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ];
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${parseInt(year)}`;
  }

  private formatMoney(amount: any, decimalCount = 2, decimal = ',', thousands = '.'): string {
    try {
      if (amount === 0 || amount === '-') {
        return '-';
      }

      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? '-' : '';

      let i = parseInt(
        (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
      ).toString();
      let j = i.length > 3 ? i.length % 3 : 0;

      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands)
      );
    } catch (e) {
      return '';
    }
  }

  private formatRate(rate: any): string {
    if (rate === null || rate === undefined || rate === '-') {
      return '-';
    }
    const rateNumber = parseFloat(rate);
    return (
      rateNumber.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + '%'
    );
  }
}
